// Versão do app - gerado automaticamente
export const APP_VERSION = '5.50'
export const BUILD_DATE = '08/08/2026, 18:10'
